/**
 * @file The modal reducer.
 */

import { OPEN_MODAL, CLOSE_MODAL } from '../actions/modal-actions';

const initialState = {
  dialogs: {},
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [action.name]: {
            isOpen: true,
            props: action.props,
          },
        },
      };

    case CLOSE_MODAL: {
      const { [action.name]: omit, ...dialogs } = state.dialogs;

      return {
        ...state,
        dialogs: {
          ...dialogs,
        },
      };
    }

    default:
      return state;
  }
};

export default modalReducer;
